export const LIST_CALIB_FAIL = "LIST_CALIB_FAIL";
export const LIST_CALIB_SUCCESS = "LIST_CALIB_SUCCESS";
export const ONE_CALIB_SUCCESS = "ONE_CALIB_SUCCESS";
export const ONE_CALIB_FAIL = "ONE_CALIB_FAIL";
export const CREATE_CALIB_SUCCESS = "CREATE_CALIB_SUCCESS";
export const CREATE_CALIB_FAIL = "CREATE_CALIB_FAIL";
export const ME_CALIB_FAIL = "ME_CALIB_FAIL";
export const ME_CALIB_SUCCESS = "ME_CALIB_SUCCESS";
export const DEACTIVATE_CALIB_SUCCESS = "DEACTIVATE_CALIB_SUCCESS";
export const DEACTIVATE_CALIB_FAIL = "DEACTIVATE_CALIB_FAIL";
export const SEARCH_CALIB_SUCCESS = "SEARCH_CALIB_SUCCESS";
export const SEARCH_CALIB_FAIL = "SEARCH_CALIB_FAIL";
export const LIST_CALIB_DESACTIVER_SUCCESS = "LIST_CALIB_DESACTIVER_SUCCESS";
export const LIST_CALIB_DESACTIVER_FAIL = "LIST_CALIB_DESACTIVER_FAIL";
export const CHANGER_ACCES_CALIB_SUCCESS = "CHANGER_ACCES_CALIB_SUCCESS";
export const CHANGER_ACCES_CALIB_FAIL = "CHANGER_ACCES_CALIB_FAIL";


export const UPDATE_CALIB_SUCCESS = "CREATE_CALIB_SUCCESS";
export const UPDATE_CALIB_FAIL = "CREATE_CALIB_FAIL";

export const RESET_STATUS_LIST = 'RESET_STATUS_LIST';
